import { IDestination, CreateDestinationDTO } from '_/types/destinations/destinations.types';
import zeusSdk from '_/utils/SDKs';

export const listAll = async (params = {}): Promise<IDestination[]> => {
  const options = {
    queryParameters: {
      sort: 'name',
      sortDirection: 'ASC',
    },
    ...params,
  };
  return zeusSdk.destinations.listAll(options);
};

export const createDestination = async (destination: CreateDestinationDTO): Promise<IDestination> => {
  return zeusSdk.destinations.create(destination);
};

export const deleteDestination = async (destinationId: string): Promise<void> => {
  await zeusSdk.destinations.delete(destinationId);
};

export const updateDestination = async (destinationId: string, destination: Partial<IDestination>): Promise<IDestination> => {
  return zeusSdk.destinations.patch(destinationId, destination);
};
